import {
  assetConstants,
  type ChainMap,
  type ChainflipAsset,
  type ChainflipChain,
} from '@chainflip/utils/chainflip';
import classNames from 'classnames';
import ArbitrumLogo from '@/shared/assets/svg/chainpill-logos/arb.svg';
import BitcoinLogo from '@/shared/assets/svg/chainpill-logos/btc.svg';
import PolkadotLogo from '@/shared/assets/svg/chainpill-logos/dot.svg';
import EthereumLogo from '@/shared/assets/svg/chainpill-logos/eth.svg';
import AssethubLogo from '@/shared/assets/svg/chainpill-logos/hub.svg';
import SolanaLogo from '@/shared/assets/svg/chainpill-logos/sol.svg';

// https://www.figma.com/design/6DpozwFwDYXTu6HFsbijhZ/%F0%9F%AA%A2-Flip-UI-Kit?node-id=2534-1729&t=eUlBi5WGwXtYXAQg-4
// TODO(1.12) remove Polkadot type
const chainLogos: ChainMap<React.FC> & { Polkadot: React.FC } = {
  Bitcoin: BitcoinLogo,
  Ethereum: EthereumLogo,
  Polkadot: PolkadotLogo,
  Arbitrum: ArbitrumLogo,
  Solana: SolanaLogo,
  Assethub: AssethubLogo,
};

// https://www.figma.com/file/6DpozwFwDYXTu6HFsbijhZ/Flip-UI-Kit?type=design&node-id=1953-2258&mode=dev
const chainColors: Record<ChainflipChain, string> = {
  Bitcoin: 'bg-[#423225] text-[#F7931B] border border-[#F7931B]/20',
  Ethereum: 'bg-[#252545] text-[#8198EE] border border-[#8198EE]/20',
  Polkadot: 'bg-[#422535] text-[#EA3E99] border border-[#EA3E99]/20',
  Arbitrum: 'bg-[#213147] text-[#12AAFF] border border-[#3D628C]/20',
  Solana: 'bg-[#31183D] text-[#CDC0FF] border border-[#462A5A]',
  Assethub: 'bg-[#532038] text-[#ED0E84] border border-[#501A37]/20',
};

const ChainPill = ({ asset }: { asset: ChainflipAsset }) => {
  const { chain } = assetConstants[asset];
  const Logo = chainLogos[chain];

  return (
    <div
      className={classNames(
        'inline-flex items-center gap-x-0.5 rounded-full px-2 py-0.5 text-12',
        chainColors[chain],
      )}
    >
      <div>
        <Logo />
      </div>
      {chain}
    </div>
  );
};

export default ChainPill;
